/*
 * Color swatches on product cards (collection grid).
 * Progressive enhancement only: each swatch is a real <a href="...?variant=ID">
 * link, so with JS disabled/blocked it simply navigates to that color's variant
 * on the product page. With JS enabled, clicking a swatch instead swaps the
 * card's image in place and updates the card's links to point at that variant,
 * so browsing stays on the collection grid. Does not touch cart/checkout logic.
 */
document.addEventListener('click', function (event) {
  var swatch = event.target.closest('.card-swatch');
  if (!swatch) return;

  var wrapper = swatch.closest('.card-wrapper');
  if (!wrapper) return;

  var newImage = swatch.getAttribute('data-card-image');
  if (!newImage) return; // No swap image available, let the link navigate normally.

  event.preventDefault();

  var siblingSwatches = wrapper.querySelectorAll('.card-swatch');
  for (var i = 0; i < siblingSwatches.length; i++) {
    siblingSwatches[i].classList.remove('card-swatch--active');
    siblingSwatches[i].removeAttribute('aria-current');
  }
  swatch.classList.add('card-swatch--active');
  swatch.setAttribute('aria-current', 'true');

  var mainImage = wrapper.querySelector('.card__media .media img');
  if (mainImage) {
    mainImage.src = newImage;
    mainImage.removeAttribute('srcset');
  }

  var newHref = swatch.getAttribute('href');
  var titleLinks = wrapper.querySelectorAll('.card__heading a[href]');
  for (var j = 0; j < titleLinks.length; j++) {
    titleLinks[j].setAttribute('href', newHref);
  }

  var quickAddButtons = wrapper.querySelectorAll('[data-product-url]');
  for (var k = 0; k < quickAddButtons.length; k++) {
    quickAddButtons[k].setAttribute('data-product-url', newHref);
  }
});
